package com.eladfinish.bible.contest.screens.browse.usecases.shonot

import com.eladfinish.bible.contest.common.usecases.MakeOtiotPasukSmallerUseCase
import com.eladfinish.bible.contest.screens.browse.usecases.GetTehilim119UseCase
import com.eladfinish.bible.contest.screens.browse.usecases.GetTiqunHaklaliUseCase

interface ShonotUseCaseProvider {

    val getTehilim119UseCase: GetTehilim119UseCase
    val getTiqunHaklaliUseCase: GetTiqunHaklaliUseCase
    val makeOtiotPasukSmallerUseCase: MakeOtiotPasukSmallerUseCase

    val getRoshChodeshContentUseCase: GetRoshChodeshContentUseCase
    val getParashatHaManContentUseCase: GetParashatHaManContentUseCase
    val getTaanitTziburContentUseCase: GetTaanitTziburContentUseCase
}

class ShonotUseCaseProviderImpl(
    override val getTehilim119UseCase: GetTehilim119UseCase,
    override val getTiqunHaklaliUseCase: GetTiqunHaklaliUseCase,
    override val makeOtiotPasukSmallerUseCase: MakeOtiotPasukSmallerUseCase,
    override val getRoshChodeshContentUseCase: GetRoshChodeshContentUseCase,
    override val getParashatHaManContentUseCase: GetParashatHaManContentUseCase,
    override val getTaanitTziburContentUseCase: GetTaanitTziburContentUseCase,
) : ShonotUseCaseProvider
